import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './utils/guards/auth.guard';
import { ConsultantGuard } from './utils/guards/consultant.guard';

const routes: Routes = [
	{ path: 'home', redirectTo: '', pathMatch: 'full', data: {} },
	{ path: 'cadastro', redirectTo: 'renta-de-carros-mensual', pathMatch: 'full', data: {} },
	{
		path: 'como-funciona-renta-renault',
		redirectTo: 'institucional/como-funciona-renta-renault',
		pathMatch: 'full',
		data: {},
	},
	{
		path: 'alquiler-de-carro-empresas',
		redirectTo: 'institucional/alquiler-de-carro-empresas',
		pathMatch: 'full',
		data: {},
	},
	{ path: 'faq', redirectTo: 'institucional/faq-renta-de-carros', pathMatch: 'full', data: {} },
	{
		path: '',
		data: {},
		canActivate: [],
		loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
	},
	{
		path: 'conta',
		data: {},
		canActivate: [],
		loadChildren: () => import('./modules/account/account.module').then(m => m.AccountModule),
	},
	{
		path: 'institucional',
		loadChildren: () => import('./modules/institutional/institutional.module').then(m => m.InstitutionalModule),
	},
	{
		path: 'renta-de-carros-mensual',
		loadChildren: () => import('./modules/register/register.module').then(m => m.RegisterModule),
	},
	{
		path: 'simulador',
		loadChildren: () => import('./modules/simulation/simulation.module').then(m => m.SimulationModule),
	},
	{
		path: 'area-logada',
		loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
	},
	{
		path: 'concessionarias',
		loadChildren: () => import('./modules/dealership/dealership.module').then(m => m.DealershipModule),
	},
	{
		path: 'consultor',
		canActivate: [AuthGuard, ConsultantGuard],
		loadChildren: () => import('./modules/consultant/consultant.module').then(m => m.ConsultantModule),
	},
	{
		path: '**',
		loadChildren: () => import('./modules/not-found/not-found.module').then(m => m.NotFoundModule),
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			initialNavigation: 'enabledBlocking',
			scrollPositionRestoration: 'enabled',
		}),
	],
	exports: [RouterModule],
})
export class AppRoutingModule {}
